// ** Auth Endpoints
export default {
  loginEndpoint: '/connect/token',
  registerEndpoint: '/api/account/register',
  refreshEndpoint: '/connect/token',
  logoutEndpoint: '/api/account/logout',
  mainEndPoint: '/api/app/',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
